export const initQueryData = { fieldName: "", operator: "", value: "", filterType: "" }
